export default {
    props: {
      loading: {
        type: Boolean,
        required: true
      }
    }
  }